import {useContext} from 'react';

import {AnalyticsSearchIdContext} from './AnalyticsSearchIdProvider';

const useAnalyticsSearchId = (): string | undefined => useContext(AnalyticsSearchIdContext);

export default useAnalyticsSearchId;
